import {
  useCallback,
  useState,
} from 'react';
import { BusinessModel } from '../../interfaces/BusinessModel.interface';
import IntakeConfig from '../../interfaces/IntakeConfig.interface';
import fetchChargebeeHostedPage from '../../services/intake/fetchChargebeeHostedPage';
import reserveBusiness from '../../services/intake/reserveBusiness';
import rollbar from '../../services/intake/rollbar';
import getCoupons from './getCoupons';

const useBusinessCompleteCallback = (config: IntakeConfig, callback: (business: BusinessModel) => void) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>();

  const onBusinessComplete = useCallback(
    async (data: BusinessModel) => {
      setError(null);
      setLoading(true);

      try {
        const { id, token } = await reserveBusiness(data);
        const newBusiness = {
          ...data,
          id,
          token,

        };
        const hostedPageUrl = await fetchChargebeeHostedPage({
          business: newBusiness,
          partnerCode: config.partner.channelPartnerCode,
          coupons: getCoupons(newBusiness, config),
        });
        newBusiness.hostedPageUrl = hostedPageUrl;

        rollbar.info('Partner Checkout Started', newBusiness);

        callback(newBusiness);
      } catch (err) {
        setError(err);
      }

      setLoading(false);
    },
    [],
  );

  return [onBusinessComplete, loading, error];
};

export default useBusinessCompleteCallback;
